import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
export function OwnerFinderCta() {
  return <section className="py-24 bg-blue-600 relative overflow-hidden" data-id="element-3660">
      <div className="absolute inset-0 opacity-10 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')]" data-id="element-3661"></div>
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center" data-id="element-3662">
        <h2 className="text-4xl md:text-5xl font-bold text-white mb-6 leading-tight" data-id="element-3663">
          Start finding local business owners today
        </h2>
        <p className="text-xl text-white/80 mb-10 leading-relaxed max-w-2xl mx-auto" data-id="element-3664">
          Join modern growth teams using Openmart to find business owner
          contacts, verified emails, and launch outreach at scale.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-3665">
          <a href="http://app.openmart.com/register" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 px-8 py-4 bg-white text-blue-600 font-bold rounded-full hover:bg-blue-50 transition-colors text-lg w-full sm:w-auto justify-center" data-id="element-3666">
            Try for free <ArrowRightIcon className="w-5 h-5" data-id="element-3667" />
          </a>
        </div>
      </div>
    </section>;
}